module.exports = __webpack_public_path__ + "img/cluster-validation.d15845c3.png";